// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Implement corner product.
 * @author James Reid
 */

// @ts-check

// @@imports-module
import { Product } from "./Product.js"

// @@imports-types
import {
    ProductData,
    TRIM_COLORS,
    TRIM_TYPES,
    EDGE_TYPES,
    PRODUCT_DISPLAY_CATEGORIES
} from "../types/index.js"

// @@body
class Corner extends Product {
    /**
     * Construct corner product from data returned from server.
     * @param {ProductData} data Product data returned from server.
     * @param {any} match Regexp match data for internal calculator sku code
     * pertaining to this extended class.
     */
    constructor(data, match) {
        super(data)

        // Parse regexp data.
        const { corner, type, material, color } =
            /** @type {Object<string, string>} */ (match.groups)

        // Set extended class values.
        this.cornerAngle = corner === "I" ? 3 * Math.PI / 2
            : corner === "E" ? Math.PI / 2
            : NaN
        this.edgeType = type === "K" ? EDGE_TYPES.raisedKerb
            : type === "D" ? EDGE_TYPES.gutterDrip
            : null
        this.type = material === "C" ? TRIM_TYPES.cellular
            : material === "S" ? TRIM_TYPES.solid
            : null
        this.color = color === "B" ? TRIM_COLORS.black
            : color === "G" ? TRIM_COLORS.grey
            : null
        this.displayCategory = PRODUCT_DISPLAY_CATEGORIES.pvcTrim
    }
}

// @@exports
export { Corner }
